import styles from "./HeaderCrypto.module.scss";
import Logo from "../../../styles/pics/logo.png";
export default function HeaderCrypto() {
  return (
    <>
      <div className={styles.container}>
        <img src={Logo} alt="ArzFi-Logo" width={80} height={50} />
      </div>
    </>
  );
}
